// extracted by mini-css-extract-plugin
export default {"root":"CreateEditFeedPage_root__8j2P1","header":"CreateEditFeedPage_header__fRFom","cancelButton":"CreateEditFeedPage_cancelButton__MuJBt"};